import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BrokerCalculator from "@/components/BrokerCalculator";
import CTABanner from "@/components/CTABanner";
import { RelatedLinks } from "@/components/SEOBlocks";
import PageHero from "@/components/PageHero";
import { Calculator } from "lucide-react";

export default function CalculatorFullPage() {
  const { t } = useTranslation();
  const CALC_RELATED = [
    { to: "/account-comparison",  label: t("pages.calculator.relAccountTypes"),  tagline: t("pages.calculator.relAccountTagline") },
    { to: "/live-spreads",        label: t("pages.calculator.relLiveSpreads"),   tagline: t("pages.calculator.relLiveSpreadsTagline") },
    { to: "/markets/forex",       label: t("pages.calculator.relForex"),         tagline: t("pages.calculator.relForexTagline") },
    { to: "/symbols",             label: t("pages.calculator.relSymbols"),       tagline: t("pages.calculator.relSymbolsTagline") },
  ];
  return (
    <div data-testid="page-calculator-full" className="relative overflow-x-hidden">
      <Navbar />
      <PageHero
        breadcrumb={[{ label: t("pages.calculator.breadcrumb") }]}
        pill={{ Icon: Calculator, text: t("pages.calculator.pill") }}
        title={t("pages.calculator.title")}
        accent={t("pages.calculator.accent")}
        subline={t("pages.calculator.subline")}
        primary={{ label: t("pages.calculator.btnSpreads"),  to: "/live-spreads" }}
        secondary={{ label: t("pages.calculator.btnSymbols"), to: "/symbols" }}
      />
      <main className="pb-20">
        <BrokerCalculator />
        <RelatedLinks items={CALC_RELATED} />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
